// Widget de estadisticas 

import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useUser } from '../UserContext';
import { formatDashedDate } from '../util/DateUtil';
import { apiFetchJson } from '../fetchWrapper';

export default function StatsWidget() {
  const { user, setUser } = useUser();
  const [error, setError] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [sites, setSites] = useState([]);
  const [clients, setClients] = useState([]);
  const [scheduledShiftsToday, setScheduledShiftsToday] = useState([]);
  const [attendancesToday, setAttendancesToday] = useState([]);

  useEffect(() => {
    const now = new Date();
    const dateStr = formatDashedDate(now);
  
    Promise.all([
      apiFetchJson(`/api/scheduled-shifts?startDate=${dateStr}&endDate=${dateStr}`),
      apiFetchJson(`/api/attendances?startDate=${dateStr}&endDate=${dateStr}`),
      apiFetchJson('/api/employees'),
      apiFetchJson('/api/sites'),
      apiFetchJson('/api/clients')
    ])
      .then(([scheduledShiftsData, attendancesData, employeesData, sitesData, clientsData]) => {
        setScheduledShiftsToday(scheduledShiftsData || []);
        setAttendancesToday(attendancesData || []);
        setEmployees(employeesData || []);
        setSites(sitesData || []);
        setClients(clientsData || []);
        setError(null);
      })
      .catch(err => {
        console.error('Failed to load data', err);
        setError(err.message || 'Failed to load');
      });
  }, []);

  const getTotalClientElements = () => {
    return clients.reduce((total, client) => total + (client.elementsNumber || 0), 0);
  };

  const getUniqueAttendanceCount = () => {
    if (!Array.isArray(attendancesToday) || attendancesToday.length === 0) return 0;
    const shiftIds = new Set(
      attendancesToday
        .map(att => att.scheduledShiftId)
        .filter(id => id != null)
    );
    return shiftIds.size;
  };

  const getFaltasHoy = () => {
    const scheduledCount = Array.isArray(scheduledShiftsToday) ? scheduledShiftsToday.length : 0;
    return Math.max(0, scheduledCount - getUniqueAttendanceCount());
  };

  return (
    <Card elevation={3}
      sx={{
        height: 325,
        borderRadius: 3,
        backgroundColor: '#eef0f2',
        color: 'black'
      }}
    >
      <CardContent>
        <Typography variant="h6" fontSize={25} fontWeight={"bold"} gutterBottom>
          Estadísticas
        </Typography>

        <Grid container columns={2} spacing={2}>

          <Grid size={1}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="caption" sx={{ fontSize: 16, fontWeight: "bold" }}>
                Empleados totales
              </Typography>
              <Typography variant="h2" sx={{ color: "#1976d2", fontWeight: "bold" }}>
                {employees?.length ?? 0}
              </Typography>
            </Box>
          </Grid>

          <Grid size={1}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="caption" sx={{ fontSize: 16, fontWeight: "bold" }}>
                Empleados activos
              </Typography>
              <Typography variant="h2" sx={{ color: "#ed6c02", fontWeight: "bold" }}>
                {getTotalClientElements()}
              </Typography>
            </Box>
          </Grid>

          <Grid size={1}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="caption" sx={{ fontSize: 16, fontWeight: "bold" }}>
                Turnos hoy
              </Typography>
              <Typography variant="h2" sx={{ color: "#2e7d32", fontWeight: "bold" }}>
                {scheduledShiftsToday?.length ?? 0}
              </Typography>
            </Box>
          </Grid>

          <Grid size={1}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="caption" sx={{ fontSize: 16, fontWeight: "bold" }}>
                Faltas hoy
              </Typography>
              <Typography variant="h2" sx={{ color: "#9c27b0", fontWeight: "bold" }}>
                {getFaltasHoy()}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
